module.exports = __webpack_public_path__ + "static/img/cronus.84c5d61.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/cronus.png
// module id = 5kCg
// module chunks = 0